import React, { memo, FC, ComponentType } from "react";
import userService from "src/shared/services/user.service";
import { Route, Redirect, RouteProps } from "react-router";

const ProtectedRoute: FC<RouteProps & { component: ComponentType<any> }> = ({ component: Comp, ...rest }) => (
  <Route {...rest} render={(props) => (userService.isLoggedIn() ? <Comp {...props} /> : <Redirect to="/login" />)} />
);

export default memo(ProtectedRoute);
